import React, { Component } from 'react';
import './index.less';
import Footer from "../../components/Footer";
import Nav from '../../components/Nav/index';
import anime from 'animejs';
import { message } from "antd";
import {withRouter} from "react-router-dom";
import Loader from '../../components/loader';
import arrow from "../../assets/img/arrow_left.png";
import close from "../../assets/img/close.png";
import Axios from "../../axios";
import Utils from "../../utils/utils";
import Fade from 'react-reveal/Fade';
import Zoom from 'react-reveal/Zoom';
import Slider from "react-slick";


const rdom = require('react-dom');

class ProDetail extends Component {
    state = {
        isLoading: true,
        isAnimate: true,
        detailItem: [],
        nextItem: []
    }
    componentWillMount() {
        let proItems = sessionStorage.getItem('proItems');
        proItems = JSON.parse(proItems);
        console.log(proItems)
        this.setState({
            proItems
        })
        let id = this.props.match.params.id;
        proItems.map((item, index) => {
            console.log(item)
            if (item.id === id) {
                console.log(index)
                console.log(proItems[index + 1])
                if (index < (proItems.length - 1)) {
                    let nextItem = proItems[index + 1];
                    this.setState({
                        nextItem
                    })
                } else {
                    let nextItem = proItems[0];
                    this.setState({
                        nextItem
                    })
                }
            }
        })
        let params = { id: this.props.match.params.id }
        this.detailsRequest(params);
    }
    scrollFunc= (e) =>{
        e = e || window.event;
        var isEn = this.state.isOpacity;
        if (e.wheelDelta) { //第一步：先判断浏览器IE，谷歌滑轮事件
         if (e.wheelDelta > 0) { //当滑轮向上滚动时
        //   console.log("滑轮向上滚动");
         }
         if (e.wheelDelta < 0) { //当滑轮向下滚动时
        //   console.log("滑轮向下滚动");
            if (this.state.isAnimate) {
                this.setState({
                    isAnimate: false
                })
            }
         }
        } else if (e.detail) { //Firefox滑轮事件
         if (e.detail> 0) { //当滑轮向上滚动时
        //   console.log("滑轮向上滚动");
         }
         if (e.detail< 0) { //当滑轮向下滚动时
        //   console.log("滑轮向下滚动");
            if (this.state.isAnimate) {
                this.setState({
                    isAnimate: false
                })
            }
         }
        }
       }
    componentDidMount(){
        if (document.addEventListener) {
            document.addEventListener('DOMMouseScroll', this.scrollFunc.bind(this), false);
        }
        window.onmousewheel = document.onmousewheel = this.scrollFunc.bind(this);
    }
    //鼠标悬停
    handleOver = () => {
        var textWrapper = document.querySelector('.enter-txt');
        textWrapper.innerHTML = textWrapper.textContent.replace(/([^\x00-\x80]|\w)/g, "<span class='letter'>$&</span>");
        anime.timeline({ loop: 1 })
            .add({
                targets: '.letter',
                translateY: [0,-14, 0],
                easing: "easeOutExpo",
                duration: 300,
                delay: function (el, i) {
                    return 100 + 40 * i;
                }
            })
    }
    //鼠标滚动
    handleScroll(e) {
        const ele = rdom.findDOMNode(this);
        const scrollTop = (e.srcElement ? e.srcElement.documentElement.scrollTop : false)
            || window.pageYOffset
            || (e.srcElement ? e.srcElement.body.scrollTop : 0);
        const clientHeight = (e.srcElement ? e.srcElement.documentElement.clientHeight : false)
            || window.innerHeight
            || (e.srcElement ? e.srcElement.body.clientHeight : 0);
        if (e.nativeEvent.deltaY <= 0) {
            /* scrolling up */
            if (ele.scrollTop <= 0) {
                e.preventDefault();
                console.log('scrolling up')
            }
        } else {
            /* scrolling down */
            console.log('scrolling down')
            if (scrollTop + clientHeight >= ele.scrollHeight * (2 / 3)) {
                e.preventDefault();
                if (this.state.isAnimate) {
                    this.setState({
                        isAnimate: false
                    })
                }
            }
        }
    }
    //获取下一产品
    nextClick = (e, id) => {
        // window.location.reload();
        const { proItems, detailItem } = this.state;
        console.log(proItems)
        console.log(id)
        proItems.map((item, index) => {
            console.log(item)
            if (item.id == id) {
                if (index < (proItems.length - 1)) {
                    let nextItem = proItems[index + 1];
                    let _pro = proItems[index];
                    this.detailsRequest({ id: _pro.id })
                    this.setState({
                        nextItem,
                        detailItem: _pro
                    })
                } else {
                    let nextItem = proItems[0];
                    let _pro = proItems[0];
                    this.setState({
                        nextItem,
                        detailItem: _pro
                    })
                    this.detailsRequest({ id: _pro.id })
                }
            }
        })
        // proItems.map((item, index) => {
        //     if (item.id === id) {
        //         if (index < (proItems.length - 1)) {
        //             console.log(proItems[index + 1])
        //             let nextItem = proItems[index + 1];
        //             let _pro = proItems[index];
        //             console.log(_pro)
        //             this.setState({
        //                 nextItem,
        //                 detailItem: _pro
        //             })
        //         } else {
        //             let nextItem = proItems[0];
        //             let _pro = proItems[1];
        //             console.log(proItems[1])
        //             this.setState({
        //                 nextItem,
        //                 detailItem: _pro
        //             })
        //         }
        //         window.scrollTo(0, 0);
        //     }
        // })
    }
    //在componentWillUnmount，进行scroll事件的注销
    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }
    //详情请求
    detailsRequest = (params) => {
        let _this = this;
        this.setState({
            isLoading: true,
        })
        Axios.get({
            block: '/api/post',
            url: '/detail',
            params: params,
        }).then((data) => {
            console.log(data)
            if (data.code === 0) {
                let proItems = [];
                let items = data.data;
                let item = items.post;
                let meta = items.metas[0].value;
                let _meta = JSON.parse(meta);
                let mPics = [];
                console.log(_meta)
                _meta.map((item, index) => {
                    item.showurl = Utils.getUrl(item.showurl);
                    mPics.push(item.showurl);
                })
                console.log(_meta)
                let proP = JSON.parse(meta)[0];
                item.meta = mPics;
                proItems.push(item);
                this.setState({
                    detailItem: proItems[0]
                })
                console.log(this.state.detailItem.meta)
            } else {
                message.error(data.msg)
            }
        /*    this.setState({
                isLoading: false
            })*/
            setTimeout(function () {
                _this.setState({
                    isLoading: false
                })
            },1000)
            // this.animation();
        }).catch((error) => {
            console.log(error);
        })
    }
    render() {
        let { isLoading, detailItem, nextItem } = this.state;
        const proId = sessionStorage.getItem('proId');
        console.log(nextItem)
        detailItem = detailItem ? detailItem : [];
        console.log(detailItem)
        let imgBox = detailItem.meta ? detailItem.meta : '';
        console.log(imgBox)
        const settings = {
            dots: false,
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            vertical: true,
            verticalSwiping: true,
            autoplaySpeed: 3000,
            autoplay: true,
            fade: true,
            // cssEase: "fade",
            arrows: false
        }
        return (

            <div>
                {
                    isLoading ? <Loader cTitle="产品" eTitle="PRODUCT" />
                        : <div className="pro-detail" ref="bodyBox" >
                            <header className="header-title">
                                <h1 className="white">
                                    <a href="javaScript:void(0)" onClick={()=>this.props.history.push(`/pro/${proId}`)}>
                                        <p className="back-txt">close</p>
                                        {/*<img src={close} className="back-icon" width="20" alt="close"/>*/}
                                    </a>
                                </h1>
                            </header>
                            <div className="detail-info">
                                <div className="info-exp">
                                    <h4 className="left title-box">
                                        <Zoom cascade>
                                            {detailItem.title ? detailItem.title : ''}
                                        </Zoom>
                                    </h4>
                                    <h6 className="right cent-box">
                                        <Fade bottom delay={500}>
                                            {detailItem.description ? detailItem.description : ''}
                                        </Fade>
                                    </h6>
                                </div>
                            </div>
                            <div className="main-image" >
                                <Slider {...settings}>
                                    {
                                        imgBox ? imgBox.map((item, index) => {
                                            return (
                                                <img src={item} key={index} style={{height:'100%'}}/>
                                            )
                                        }) : ''
                                    }
                                </Slider>
                            </div>
                            <div className="detail-switch">
                                <div className="info-exp">
                                    <h4 className="left sub-title">
                                        <Zoom cascade>
                                            {nextItem.title ? nextItem.title : ''}
                                        </Zoom>
                                    </h4>
                                    <div className="right">
                                        <h6 className="sub-box">
                                            <Fade delay={1000}>
                                                {nextItem.post.description ? nextItem.post.description : ''}
                                            </Fade>
                                        </h6>
                                        <a className="next" onMouseOver={this.handleOver} onClick={(e) => this.nextClick(e, nextItem.id)}>
                                            <div className='img-yellow'></div>
                                            <div className="next-img"></div>
                                            <div className='enter-txt-wrap'><div className="enter-txt">enter</div></div>
                                        </a>
                                    </div>
                                </div>
                                <Footer/>
                                 {/*<Nav/>*/}
                            </div>

                        </div>
                }
            </div>
        )
    }
}
export default withRouter(ProDetail);
